// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"faq_faqSection__s3JM6","faqHeading":"faq_faqHeading__3v3Rj","QandA":"faq_QandA__1Ut62"};